import { render, staticRenderFns } from "./UploadDetail.vue?vue&type=template&id=01d5c972"
import script from "./UploadDetail.vue?vue&type=script&lang=js"
export * from "./UploadDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports